import { Injectable } from '@angular/core';
import * as _ from 'lodash';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';

type Predicate = (e: any) => boolean;

@Injectable()
export class UbiFilterService {

  protected _currentFilter = null;
  protected _currentFilterNL = null;

  constructor() { }

  public setCurrentFilter(value): any {
    this._currentFilter = value;
  }

  public setCurrentFilterNL(value): any {
    this._currentFilterNL = value;
  }

  public getCurrentFilter(): any {
    return this._currentFilter;
  }

  public getCurrentFilterNL(): any {
    return this._currentFilterNL;
  }

  public condition(expression: any): Predicate {
    const { key, operator, value } = expression;

    const predicate = (p: any) => {
      switch (operator) {
        case 'equal': return p[key] == value; // Used == because === can't be used, because sometimes numeric are received as string
        case 'not_equal': return p[key] != value; // Used == because === can't be used, because sometimes numeric are received as string
        case 'greater': return p[key] > value;
        case 'greater_or_equal': return p[key] >= value;
        case 'less': return p[key] < value;
        case 'less_or_equal': return p[key] <= value;
        case 'between': return p[key] >= value[0] && p[key] <= value[1];
        case 'not_between': return p[key] < value[0] || p[key] > value[1];
        default: throw Error('Invalid comparison in filter');
      }
    };

    return predicate;

  }

  public conditionString(expression: any): Predicate {
    const { key, operator, value } = expression;

    const predicate = (p: any) => {
      switch (operator) {
        case 'equal': return p[key].toLowerCase() === value;
        case 'not_equal': return p[key].toLowerCase() !== value;
        case 'begins_with': return p[key].toLowerCase().indexOf(value) === 0;
        case 'contains': return p[key].toLowerCase().indexOf(value) >= 0;
        case 'greater': return p[key].toLowerCase() > value;
        case 'greater_or_equal': return p[key].toLowerCase() >= value;
        case 'less': return p[key].toLowerCase() < value;
        case 'less_or_equal': return p[key].toLowerCase() <= value;
        case 'between': return p[key].toLowerCase() >= value[0] && p[key].toLowerCase() <= value[1];
        case 'not_between': return p[key].toLowerCase() < value[0] || p[key].toLowerCase() > value[1];
        default: throw Error('Invalid comparison in filter');
      }
    };

    return predicate;

  }


  public conditionComposed(expression: any): Predicate {
    let { key, operator, value } = expression;

    let key2 = '';

    if (key.indexOf('.') >= 0) {
      const splitted = key.split('.', 2);
      if (splitted.length > 1) {
        key = splitted[0];
        key2 = splitted[1];
      }
    }

    const predicate = (p: any) => {
      switch (operator) {
        case 'equal': return p[key][key2] == value; // Used == because === can't be used, because sometimes numeric are received as string
        case 'not_equal': return p[key][key2] != value; // Used == because === can't be used, because sometimes numeric are received as string
        case 'begins_with': return p[key][key2].indexOf(value) === 0;
        case 'contains': return p[key][key2].indexOf(value) >= 0;
        case 'greater': return p[key][key2] > value;
        case 'greater_or_equal': return p[key][key2] >= value;
        case 'less': return p[key][key2] < value;
        case 'less_or_equal': return p[key][key2] <= value;
        case 'between': return p[key][key2] >= value[0] && p[key][key2] <= value[1];
        case 'not_between': return p[key][key2] < value[0] || p[key][key2] > value[1];
        default: throw Error('Invalid comparison in filter');
      }
    };

    return predicate;

  }

  public conditionStringComposed(expression: any): Predicate {
    let { key, operator, value } = expression;

    let key2 = '';

    if (key.indexOf('.') >= 0) {
      const splitted = key.split('.', 2);
      if (splitted.length > 1) {
        key = splitted[0];
        key2 = splitted[1];
      }
    }

    const predicate = (p: any) => {
      switch (operator) {
        case 'equal': return p[key][key2].toLowerCase() === value;
        case 'not_equal': return p[key][key2].toLowerCase() !== value;
        case 'begins_with': return p[key][key2].toLowerCase().indexOf(value) === 0;
        case 'contains': return p[key][key2].toLowerCase().indexOf(value) >= 0;
        case 'greater': return p[key][key2].toLowerCase() > value;
        case 'greater_or_equal': return p[key][key2].toLowerCase() >= value;
        case 'less': return p[key][key2].toLowerCase() < value;
        case 'less_or_equal': return p[key][key2].toLowerCase() <= value;
        case 'between': return p[key][key2].toLowerCase() >= value[0] && p[key][key2].toLowerCase() <= value[1];
        case 'not_between': return p[key][key2].toLowerCase() < value[0] || p[key][key2].toLowerCase() > value[1];
        default: throw Error('Invalid comparison in filter');
      }
    };

    return predicate;

  }

  public and(predicates: Predicate[]): Predicate {
    return (e) => predicates.every(p => p(e));
  }

  public or(predicates: Predicate[]): Predicate {
    return (e) => predicates.some(p => p(e));
  }

  public getCurrentFilterAsExpression(filter): any {
    const conditions: Predicate[] = [];

    filter.rules.forEach(element => {

      if (element.type === 'string') {

        if (element.field.indexOf('.') > -1) {
          conditions.push(this.conditionStringComposed({ key: element.field,
            value: element.value.toLowerCase(), operator: element.operator }));
        } else {
          conditions.push(this.conditionString({ key: element.field,
            value: element.value.toLowerCase(), operator: element.operator }));
        }

      } else if (element.field.indexOf('.') > -1) {
        conditions.push(this.conditionComposed({ key: element.field, value: element.value, operator: element.operator }));
      } else {
        conditions.push(this.condition({ key: element.field, value: element.value, operator: element.operator }));
      }

    });

    return this.and(conditions);
  }

}



// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/theme/services/ubiFilter/ubiFilter.service.ts